<template>
  <f7-page @page:beforein="beforein">
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('fertilization') }}</span>
      </template>
    </navbar>
    <f7-block-title class="block-title-result">
      <span :class="`color-title-${selection}`">
        {{ `${$t(enabledRecommendationNutrientConcentration
          ? 'result.manure.title_recommendation_manure'
          : 'result.manure.title_recommendation_manure_2')}` }}
      </span>
    </f7-block-title>
    <div
      style="padding-top: 1rem"
      class="transparent headers-initial"
    >
      <div v-if="selection === 'GreenHouse'">
        <ManureResult :data="enabledRecommendationNutrientConcentration ? data : twoPeriodsData" />
      </div>
      <f7-block>
        <div
          class="content-note"
          style="margin-top: 1rem; max-width: 100%;"
        >
          <span class="note">
            En los cultivos sandía, calabacín y berenjena solo se ofrecen resultados de riego y N
          </span>
        </div>
        <div
          class="select-button"
        >
          <DxButton
            name="btnSignIn"
            class="selected-button"
            style="color:#FFFFFF"
            @click="openPopUpCorrectiveNitrogenManagement"
          >
            {{ $t('result.manure.manure_nitro') }}
          </DxButton>
        </div>
        <div v-if="loaded && enabledRecommendationNutrientConcentration">
          <ChartManure
            :data="data"
            :key-name="keyName"
          />
        </div>
      </f7-block>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/detailManure/extract/"
            popover-close
            :title="$t('result.manure.details_result')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-GreenHouse"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
    </f7-block-footer>
    <DxPopUpCorrectiveNitrogenManagement />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DxButton from 'devextreme-vue/button';
import navbar from '../../../../components/navbar/NavBar.vue';
import ManureResult from '../../../../components/manureResult/index.vue';
import ChartManure from '../../../../components/manureResult/chartManure/index.vue';
import DxPopUpCorrectiveNitrogenManagement from '../../../../components/manureResult/popUpCorrectiveNitrogenManagement/index.vue';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS } from '../../../../js/constants';

export default {
  name: 'ManurePageResultGH',
  components: {
    navbar,
    ManureResult,
    ChartManure,
    DxButton,
    DxPopUpCorrectiveNitrogenManagement,
  },
  data() {
    return {
      data: [],
      graphsData: [],
      twoPeriodsData: [],
      keyName: '',
      loaded: false,
      enabledRecommendationNutrientConcentration: true,
      NUMBER_OF_DECIMALS,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject', 'enabledPopUpCorrectiveNitrogenManagement',
    ]),
    selectionClass() {
      return this.selection === 'GreenHouse' ? 'dx-btn-success color-orange' : 'dx-btn-success open-air';
    },
  },
  methods: {
    beforein() {
      this.$f7.preloader.show();
      this.keyName = this.$f7.views.main.router.currentRoute.path;

      this.graphsData = this.resultProject.result.soil_needs_N.map((soilNeedsN, index) => ({
        ddt: index,
        date: this.resultProject.result.dates[index],
        period: Math.trunc(index / 28) + 1,
        soil_needs_N_fixed: Number(soilNeedsN
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_needs_Ca_fixed: Number(this.resultProject.result.soil_needs_Ca[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_needs_K_fixed: Number(this.resultProject.result.soil_needs_K[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_needs_Mg_fixed: Number(this.resultProject.result.soil_needs_Mg[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_needs_P_fixed: Number(this.resultProject.result.soil_needs_P[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_extractions_N_fixed: Number(this.resultProject.result.soil_extractions_N[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_extractions_Ca_fixed: Number(this.resultProject.result.soil_extractions_Ca[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_extractions_K_fixed: Number(this.resultProject.result.soil_extractions_K[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_extractions_Mg_fixed: Number(this.resultProject.result.soil_extractions_Mg[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_extractions_P_fixed: Number(this.resultProject.result.soil_extractions_P[index]
          .toFixed(this.NUMBER_OF_DECIMALS)),
        soil_needs_N: soilNeedsN,
        soil_needs_Ca: this.resultProject.result.soil_needs_Ca[index],
        soil_needs_K: this.resultProject.result.soil_needs_K[index],
        soil_needs_Mg: this.resultProject.result.soil_needs_Mg[index],
        soil_needs_P: this.resultProject.result.soil_needs_P[index],
        soil_extractions_N: this.resultProject.result.soil_extractions_N[index],
        soil_extractions_Ca: this.resultProject.result.soil_extractions_Ca[index],
        soil_extractions_K: this.resultProject.result.soil_extractions_K[index],
        soil_extractions_Mg: this.resultProject.result.soil_extractions_Mg[index],
        soil_extractions_P: this.resultProject.result.soil_extractions_P[index],
      }));

      const prepareData = [];

      if (this.resultProject.result
          && this.resultProject.result.soil_nutrien_concentrations_4weeks) {
        this.resultProject.result.soil_nutrien_concentrations_4weeks
          .initial_day.forEach((item, index) => {
            prepareData.push(
              {
                ddt: index + 1,
                period: index + 1,
                date: `${item} al ${this.resultProject.result.soil_nutrien_concentrations_4weeks.last_day[index]}`,
                soil_needs_N: Number(this.resultProject.result.soil_nutrien_concentrations_4weeks
                  .nitrogen[index]
                  .toFixed(this.NUMBER_OF_DECIMALS)),
                soil_needs_Ca: Number(this.resultProject.result.soil_nutrien_concentrations_4weeks
                  .calcium[index]
                  .toFixed(this.NUMBER_OF_DECIMALS)),
                soil_needs_K: Number(this.resultProject.result.soil_nutrien_concentrations_4weeks
                  .potassium[index]
                  .toFixed(this.NUMBER_OF_DECIMALS)),
                soil_needs_Mg: Number(this.resultProject.result.soil_nutrien_concentrations_4weeks
                  .magnesium[index]
                  .toFixed(this.NUMBER_OF_DECIMALS)),
                soil_needs_P: Number(this.resultProject.result.soil_nutrien_concentrations_4weeks
                  .phosphorus[index]
                  .toFixed(this.NUMBER_OF_DECIMALS)),
              },
            );
          });
      }

      this.data = prepareData;
      this.twoPeriodsData = this.data;
      this.loaded = true;
      this.$f7.preloader.hide();
    },
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/', { reloadCurrent: true });
    },
    switchRecommendationNutrientConcentration() {
      this.enabledRecommendationNutrientConcentration = !this.enabledRecommendationNutrientConcentration;
    },
    goToTabsManureDetails() {
      this.$f7.views.main.router.navigate('/detailManure/extract/', { reloadCurrent: true });
    },
    openPopUpCorrectiveNitrogenManagement() {
      this.setEnabledPopUpCorrectiveNitrogenManagement(true);
    },
    ...mapActions('Result', [
      'setEnabledPopUpCorrectiveNitrogenManagement',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../css/mixins.scss";
.select-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
  margin: 1rem;
  .selected-button {
    background: #FF7F26;
    border-radius: 4px;
    border-color: #fc6900;
    border-width: 3px;
    max-width: 320px;
    margin: 1rem;
    box-shadow: none;
    height: auto;
    font-size: 1rem !important;
    display: flex !important;
    line-height: initial !important;
  }
}
.dx-button-content {
  display: flex !important;
  line-height: initial !important;
}
.content-note {
  margin: 0 1rem 2rem;
  max-width: 1080px;
  text-align: center !important;
  @include md {
    margin: 2rem;
    text-align: center !important;
  }
}
.note {
  font-family: 'Roboto';
  font-style: normal;
  line-height: normal;
  color: steelblue;
  font-size: small;
  @include md {
    font-size: large;
    line-height: 28px;
  }
}

</style>
